// extracted by mini-css-extract-plugin
module.exports = {"component":"carousel-slide-content_component__uDhMu"};